// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
type TokenRetriever = () => Promise<string>

let tokenRetriever: TokenRetriever | null = null

export const setTokenRetriever = (retriever: TokenRetriever): void => {
  tokenRetriever = retriever
}

export const getAccessToken = async (): Promise<string> => {
  if (!tokenRetriever) {
    throw new Error('Access token retriever has not been initialized')
  }

  return tokenRetriever()
}
